// @ts-check
// =============================================================================
// js/ui/toast.js — small transient notifications.
//
// For "request failed", "copied to clipboard", "new pack earned!", etc.
// (cross-cutting.md: error/empty/loading states defined once and reused).
//
//   toast('Deck saved!');
//   toast('Could not reach the server', { error: true, ms: 5000 });
// =============================================================================

/** Lazily created container so toasts stack neatly. */
function holder() {
	let el = document.querySelector('.toast-holder');
	if (!el) {
		el = document.createElement('div');
		el.className = 'toast-holder';
		document.body.appendChild(el);
	}
	return el;
}

/**
 * Show a toast for a few seconds.
 * @param {string} message
 * @param {{error?: boolean, ms?: number}} [options]
 * @returns {void}
 */
export function toast(message, { error = false, ms = 3200 } = {}) {
	const el = document.createElement('div');
	el.className = 'toast' + (error ? ' toast--error' : '');
	el.textContent = message;
	holder().appendChild(el);
	setTimeout(() => el.remove(), ms);
}
